import { Navigate } from "react-router-dom";

export default function BrowseCategory() {
  return <Navigate to="/services" replace />;
}
